// a simple script for Form inputs to add empty placeholders where placeholders do not exist
// this is important for SA brand Material v3 style inputs alignment.

import Component from './Component';
import jcf from '../lib/jcf';

export default class Form extends Component {

  load() {
    // console.log('Form loaded');
    this.initForm();
    this.replaceRecaptchaText();
    // Only init country/state handler for non-preference-centre pages
    if (!window.location.pathname.includes('preference-centre')) {
      this.initUniversalCountryStateHandler();
    }
    // this.doReplaceRecaptchaText();
    super.load();
  }

  initForm() {

    document.querySelectorAll("input[type='text']:not([placeholder])").forEach(input => {
      input.setAttribute("placeholder", " ");
    });

    // This will only run if it's used from a React Native web view
    if(window.ReactNativeWebView) {
      const formIdDivEl = document.querySelector('input[type="hidden"]#formId');
      const formId = formIdDivEl?.dataset ? formIdDivEl.dataset.formId : '';
      if(!formId) return;

      const formEl = document.querySelector(`#${formId} form`);

      console.log(`formIdEl:${JSON.stringify(formEl.id)}`);
      const submitBtn = formEl.querySelector('input[type="submit"]');
      submitBtn.addEventListener('click', function (event) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "deleteAccount",
            payload: {status: true}
          })
        );
      });
    }
  }

  // doReplaceRecaptchaText() {
  //   // document.addEventListener('load', this.waitTime);
  //   // this.waitTime();
  //   this.replaceRecaptchaText();
  // }

  // waitTime() {
  //   // 1000 = 1 second
  //   setTimeout(this.replaceRecaptchaText, 1000);
  // }

  replaceRecaptchaText() {
    // console.log('replaceRecaptchaText()');

    // The exact text content to find.
    // This text should be entered in the reCAPTCHA field "helptext".
    const searchText = "GOOGLERECAPTCHA";

    // The replacement HTML content
    const replacementHtml = `
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and
    <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.
  `;

    // XPath expression to find any element whose direct text node equals searchText
    const xpathExpression = `//*[text()='${searchText}']`;
    // //*[@id="bff4785b-a844-417a-8a74-1e6c1487eb72"]/div/div[2]/div[6]/div/span

    // Use document.evaluate to find the element
    const result = document.evaluate(xpathExpression, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
    const elementToReplace = result.singleNodeValue; // Get the first matching element

    if (elementToReplace) {
      // console.log("Found element:", elementToReplace);
      elementToReplace.innerHTML = replacementHtml; // Replace its content
    } else {
      console.log(`Element with exact text "${searchText}" not found.`);
    }
  }

  initUniversalCountryStateHandler() {
    // Wait for DOM to be fully loaded
    setTimeout(() => {
      this.setupCountryStateHandler();
    }, 100); // Small delay to ensure all form elements are rendered
  }

  setupCountryStateHandler() {
    // Try to find country field using multiple possible selectors
    let countrySelect = document.querySelector('#search-filters-country') ||
                       document.querySelector('[data-alias="country"]') ||
                       document.querySelector('select[name*="country" i]');

    if (!countrySelect) {
      // No country field found, exit silently
      return;
    }

    // Function to handle state field visibility (for newsletter-signup and other forms)
    const handleStateVisibility = (selectedCountry) => {
      console.log('Form.js handling state visibility for country:', selectedCountry);

      // Find state fields using newsletter-signup selectors primarily
      let stateDropdown = document.querySelector('[data-alias="stateDropdown"]') ||
                         document.querySelector('select[name*="state" i]');

      let stateTextInput = document.querySelector('[data-alias="stateText"]') ||
                          document.querySelector('input[name*="state" i]');

      // Find parent containers for proper hiding/showing - use form-group for Umbraco forms
      let stateDropdownContainer = stateDropdown ?
        stateDropdown.closest('.form-group') : null;

      let stateTextContainer = stateTextInput ?
        stateTextInput.closest('.form-group') : null;

      console.log('Form.js found containers:', {
        stateDropdownContainer: !!stateDropdownContainer,
        stateTextContainer: !!stateTextContainer
      });

      // Show/hide based on country selection
      if (selectedCountry === 'Australia') {
        // Show dropdown, hide text input
        if (stateDropdownContainer) {
          stateDropdownContainer.style.display = 'block';
          stateDropdownContainer.classList.remove('hide');
          stateDropdownContainer.classList.remove('umbraco-forms-hidden');
          if (stateDropdown) {
            stateDropdown.disabled = false;
          }
        }
        if (stateTextContainer) {
          stateTextContainer.style.display = 'none';
          stateTextContainer.classList.add('hide');
          stateTextContainer.classList.add('umbraco-forms-hidden');
          if (stateTextInput) {
            stateTextInput.value = '';
            stateTextInput.disabled = true;
          }
        }
      } else {
        // Hide dropdown, show text input
        if (stateDropdownContainer) {
          stateDropdownContainer.style.display = 'none';
          stateDropdownContainer.classList.add('hide');
          stateDropdownContainer.classList.add('umbraco-forms-hidden');
          if (stateDropdown) {
            stateDropdown.selectedIndex = 0;
            stateDropdown.disabled = true;
          }
        }
        if (stateTextContainer) {
          stateTextContainer.style.display = 'block';
          stateTextContainer.classList.remove('hide');
          stateTextContainer.classList.remove('umbraco-forms-hidden');
          if (stateTextInput) {
            stateTextInput.disabled = false;
          }
        }
      }
    };

    // Add change event listener
    countrySelect.addEventListener('change', () => {
      const selectedCountry = countrySelect.value;
      console.log('Form.js country changed to:', selectedCountry);

      // Don't manually update JCF display - let JCF handle it
      // The JCF library will automatically update the display when the select value changes

      handleStateVisibility(selectedCountry);
    });

    // Initialize state on page load based on current selection
    handleStateVisibility(countrySelect.value);
  }

}
